import React from "react";
import LineHeader from "./LineHeader";
import ColumnContainer from "./ColumnContainer";
import '../../../assets/css/gamification2026/_tabbed_pages.scss';

const PageLine = (props) => {
  const { rows } = props

  return (
    <>
      {
        !!rows && rows.length > 0 &&
        rows.map((row, idx) => {
          const { cols } = row
          return (
            <div key={idx} className='dashboard-page-line'>
              <LineHeader {...row} />
              <div className="dashboard-columns-row">
                {cols && cols.length > 0 &&
                  cols.map((col, key) => ( <ColumnContainer key={key} {...col} />))
                }
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default React.memo(PageLine);

